export const yellowColor = '#fff2a5'
export const orangeColor = '#ff8e21'
export const redColor = '#ff3333'
export const greenColor = '#96ff8d'
export const grayColor = '#b2ae8f'
export const lightGrayColor = '#cecece'
export const blueColor = '#345de0'
